module.exports = __webpack_public_path__ + "static/img/14.7c0e8b7a.png";